"use client";

import { useEffect, useState } from "react";

const DisclaimerModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const agreed = localStorage.getItem("disclaimerAccepted");
    if (!agreed) {
      setOpen(true);
    }
  }, []);

  const handleAgree = () => {
    localStorage.setItem("disclaimerAccepted", "true");
    setOpen(false);
  };

  const handleDisagree = () => {
    // Redirect or block site access
    window.location.href = "https://www.google.com";
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 px-4">
      <div className="max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-xl bg-white p-8 shadow-2xl md:p-10 dark:bg-gray-950">
        <h2 className="mb-6 text-center text-2xl font-bold text-gray-900 md:text-3xl dark:text-white">
          Disclaimer
        </h2>

        <div className="space-y-4 text-sm leading-relaxed text-gray-700 dark:text-gray-300">
          <p>
            The Bar Council of India does not permit the solicitation of work or
            advertising by advocates. By clicking on “I AGREE” below, the User
            acknowledges and confirms that:
          </p>

          <ul className="list-disc space-y-3 pl-5">
            <li>
              There has been no advertisement, solicitation, inducement, or
              invitation of any form by us or any of our members through this
              website.
            </li>
            <li>
              The User is seeking information about us for his/her personal use.
              This information should not be construed as legal advice.
            </li>
            <li>
              The information provided on this website is solely available at
              the User’s request for informational purposes only and should not
              be interpreted as solicitation or advertisement.
            </li>
            <li>
              Any material or information obtained from this website is entirely
              at the User’s volition and does not create a lawyer-client
              relationship.
            </li>
            <li>
              Testimonials or endorsements do not guarantee outcomes. Laws may
              vary by jurisdiction.
            </li>
            <li>
              We are not liable for actions taken based on the information on
              this website.
            </li>
            <li>
              Users facing legal issues must seek independent legal advice.
            </li>
          </ul>
        </div>

        {/* Buttons */}
        <div className="mt-10 flex flex-col justify-center gap-6 sm:flex-row">
          <button
            onClick={handleAgree}
            className="rounded-lg bg-yellow-500 px-10 py-4 font-semibold text-gray-900 shadow-lg transition hover:bg-yellow-600"
          >
            I Agree
          </button>

          <button
            onClick={handleDisagree}
            className="rounded-lg bg-gray-200 px-10 py-4 font-semibold text-gray-900 transition hover:bg-gray-300 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
          >
            Disagree
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;
